// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Js_json from "rescript/lib/es6/js_json.js";
import * as Belt_Int from "rescript/lib/es6/belt_Int.js";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Caml_int32 from "rescript/lib/es6/caml_int32.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as DomEl$GameDataCore from "../DomEl.res.mjs";

function parseImageUrls(raw) {
  if (raw === undefined) {
    return [];
  }
  if (raw === "") {
    return [];
  }
  try {
    var items = Js_json.decodeArray(JSON.parse(raw));
    if (items !== undefined) {
      return Belt_Array.keepMap(items, Js_json.decodeString);
    } else {
      return [];
    }
  }
  catch (exn){
    return [];
  }
}

function prefersReducedMotion() {
  var query = matchMedia("(prefers-reduced-motion: reduce)");
  if (query == null) {
    return false;
  } else {
    return query.matches;
  }
}

function clearHeroTimer(self) {
  var id = self.timer;
  if (id !== undefined) {
    clearInterval(Caml_option.valFromOption(id));
    self.timer = undefined;
    return ;
  }
  
}

function startHeroSlideshow(self) {
  var element = self.el;
  var value = element.getAttribute("data-image-urls");
  var raw = !(value == null) ? value : undefined;
  self.lastImageUrls = raw;
  var urls = parseImageUrls(raw);
  if (urls.length < 2) {
    return ;
  }
  var slideEls = Array.from(element.querySelectorAll("img[data-slide]"));
  if (slideEls.length < 2) {
    return ;
  }
  if (prefersReducedMotion()) {
    return ;
  }
  var value$1 = DomEl$GameDataCore.data(element, "interval-ms");
  var intervalMs;
  if (value$1 === "") {
    intervalMs = 6000;
  } else {
    var ms = Belt_Int.fromString(value$1);
    intervalMs = ms !== undefined ? ms : 6000;
  }
  self.slides = slideEls;
  self.index = 0;
  var timerId = setInterval((function () {
          var slideList = self.slides;
          var currentIndex = self.index;
          var slideCount = slideList.length;
          var nextIndex = Caml_int32.mod_(currentIndex + 1 | 0, slideCount);
          var match = Belt_Array.get(slideList, currentIndex);
          var match$1 = Belt_Array.get(slideList, nextIndex);
          if (match === undefined) {
            return ;
          }
          if (match$1 === undefined) {
            return ;
          }
          var upcoming = Caml_option.valFromOption(match$1);
          var current = Caml_option.valFromOption(match);
          DomEl$GameDataCore.removeClass(current, "opacity-100");
          DomEl$GameDataCore.addClass(current, "opacity-0");
          DomEl$GameDataCore.removeClass(upcoming, "opacity-0");
          DomEl$GameDataCore.addClass(upcoming, "opacity-100");
          self.index = nextIndex;
        }), intervalMs);
  self.timer = Caml_option.some(timerId);
}

function mounted() {
  var self = this ;
  startHeroSlideshow(self);
}

function updated() {
  var self = this ;
  var value = self.el.getAttribute("data-image-urls");
  var raw = !(value == null) ? value : undefined;
  if (Caml_obj.equal(raw, self.lastImageUrls)) {
    return ;
  } else {
    clearHeroTimer(self);
    return startHeroSlideshow(self);
  }
}

function destroyed() {
  var self = this ;
  clearHeroTimer(self);
}

var heroSlideshow = {
  mounted: mounted,
  updated: updated,
  destroyed: destroyed
};

var HeroSlideshow = {
  mounted: mounted,
  updated: updated,
  destroyed: destroyed
};

export {
  parseImageUrls ,
  prefersReducedMotion ,
  clearHeroTimer ,
  startHeroSlideshow ,
  mounted ,
  updated ,
  destroyed ,
  heroSlideshow ,
  HeroSlideshow ,
}
/* mounted Not a pure module */
